"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activatePromocode = exports.loadDeliveryAddress = exports.updateRentContractAfterLogin = exports.loadRentContract = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _redux = require("../util/redux.js");

var _store = require("./store.js");

var loadRentContract = function loadRentContract(rentContractId) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState, context) {
      var rentContract;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return context.api.rentContracts.getRentContract({
                rentContractId: rentContractId
              });

            case 2:
              rentContract = _context.sent;
              dispatch({
                type: "RENT_CONTRACTS/RENT_CONTRACT_LOADED",
                payload: {
                  rentContract: rentContract
                }
              });
              return _context.abrupt("return", rentContract);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.loadRentContract = loadRentContract;

var updateRentContractAfterLogin = function updateRentContractAfterLogin(rentContractId) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch, getState, context) {
      var _yield$context$api$re, tariffOptionChanged, rentObjectPropertyRemoved, mileagePackagesRemoved;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return context.api.rentContracts.updateRentContractAfterLogin({
                rentContractId: rentContractId
              });

            case 2:
              _yield$context$api$re = _context2.sent;
              tariffOptionChanged = _yield$context$api$re.tarifOptionUpdated;
              rentObjectPropertyRemoved = _yield$context$api$re.rentobjectPropertyRemoved;
              mileagePackagesRemoved = _yield$context$api$re.mileagePackagesRemoved;
              dispatch({
                type: "RENT_CONTRACTS/RENT_CONTRACT_ASSIGNED_TO_USER",
                payload: {
                  rentContractId: rentContractId,
                  tariffOptionChanged: tariffOptionChanged,
                  rentObjectPropertyRemoved: rentObjectPropertyRemoved,
                  mileagePackagesRemoved: mileagePackagesRemoved
                }
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.updateRentContractAfterLogin = updateRentContractAfterLogin;

var loadDeliveryAddress = function loadDeliveryAddress(rentContractId) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "RENT_CONTRACTS/DELIVERY_ADDRESS",
                loadPayload: function () {
                  var _loadPayload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.t0 = rentContractId;
                            _context3.next = 3;
                            return context.api.rentContracts.getDeliveryAddress({
                              rentContractId: rentContractId
                            });

                          case 3:
                            _context3.t1 = _context3.sent;
                            return _context3.abrupt("return", {
                              rentContractId: _context3.t0,
                              deliveryAddress: _context3.t1
                            });

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  function loadPayload() {
                    return _loadPayload.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.loadDeliveryAddress = loadDeliveryAddress;

var activatePromocode = function activatePromocode(promocode) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(dispatch, getState, context) {
      var rentContractId;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              rentContractId = (0, _store.getRentContractId)(getState());
              _context6.next = 3;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "RENT_CONTRACTS/RENT_CONTRACT",
                loadPayload: function () {
                  var _loadPayload2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
                    return _regenerator["default"].wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return context.api.rentContracts.activatePromocode({
                              promocode: promocode,
                              rentContractId: rentContractId
                            });

                          case 2:
                            _context5.t0 = _context5.sent;
                            return _context5.abrupt("return", {
                              rentContract: _context5.t0
                            });

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  function loadPayload() {
                    return _loadPayload2.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.activatePromocode = activatePromocode;